import { useLayoutEffect } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { applyPageMeta, restoreDefaultMeta, PageMetaInput } from '@/utils/pageMeta';

/** Keeps the document title, description, canonical, and social tags in step with the page. */
export function usePageMeta(meta: PageMetaInput | null | undefined): void {
    useDocumentTitle(meta?.documentTitle);
    const key = meta ? JSON.stringify(meta) : '';

    useLayoutEffect(() => {
        if (!key) return undefined;
        applyPageMeta(JSON.parse(key) as PageMetaInput);
        return () => restoreDefaultMeta();
    }, [key]);
}
